<div class="text-send">
  <textarea contenteditable="true" class="text-send__pseudo-field" (keyup)="setText($event)" #editableField 
    [appRestrictInput]="disallowedChars">
    {{initialMessage}}
  </textarea>
  <button class="text-send__send-button" (click)="sendText()" [disabled]="!fieldText"></button>
</div>
